<!--
  DATA-1539 diagnostic: a direct send through MailService, bypassing the dispatch
  pipeline and the per-type templates. Per-template test sends live in the
  Transactional Email Types table above (DATA-3029).
-->
<div class="email-test-page">
  <h2>Transactional Email Test Triggers</h2>

  <!-- 1/ Direct send (raw MailService) -->
  <button
    type="button"
    mat-raised-button
      color="accent"
    data-test-id="send-test-email"
    [disabled]="sendingTestEmail"
    (click)="sendTestEmail()"
  >
    <mat-icon>outgoing_mail</mat-icon>
    1 · Direct send (raw MailService)
  </button>

  <!-- 2/ Approved in Mongo + trigger via webhook (needs a dev community id) -->
  <!-- TEMPORARILY DISABLED — mode 2 hits POST /mail/test/trigger-webhook, a
       dev-only endpoint that mutates a real community document. Kept commented
       (not removed) so it can be re-enabled for local testing. Uncomment this
       block together with the matching code in email-test.component.ts,
       mail.api-client.ts and mail.controller.ts.
  <div class="flex items-center" style="gap: 8px; padding: 4px 0">
    <input
      #ndbId
      type="text"
      placeholder="National DB ID"
      data-test-id="webhook-ndb-id"
      style="flex: 1; min-width: 0; max-width: 200px;border:1px solid black;"
    />
    <button
      type="button"
      mat-raised-button
      color="accent"
      data-test-id="trigger-webhook"
      [disabled]="triggeringWebhook"
      (click)="triggerApprovedViaWebhook(ndbId.value)"
    >
      <mat-icon>webhook</mat-icon>
      2 · Approved via webhook
    </button>
  </div>
  -->


</div>
